








































































import { Component, Mixins } from "vue-property-decorator";
import { AuthHttp } from "@/mixins/http/auth";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
@Component({})
export default class Login extends Mixins(AuthHttp) {
	loading: boolean = false;
	formValid: boolean = false;
	private emailAddress: string = "";
	private password: string = "";
	redirectTo: string = "";
	defaultRedirectTo: string = "/dashboard";
	showAlert: boolean = false;
	alertMessage: string = "";
	showResendVerifyEmail: boolean = false;
	verificationEmailReSent: boolean = false;
	sendingVerificationEmail: boolean = false;

	private emailRules = [
		(inputText: string) => this.isSet(inputText) || "E-mail is required",
		(inputText: any) => /.+@.+/.test(inputText) || "E-mail must be valid",
	];

	private passwordRules = [(inputText: string) => this.isSet(inputText) || "Password is required"];

	mounted() {
		this.parseRouteErrorParam();
		this.parseRouteRedirectParam();
	}

	parseRouteErrorParam() {
		if (this.$route.query.error) {
			this.alertMessage = this.$route.query.error.toString();
			this.showAlert = true;
		}
	}

	parseRouteRedirectParam() {
		if (this.$route.query.redirectTo) {
			this.redirectTo = this.$route.query.redirectTo.toString();
		}
	}

	attemptLogin() {
		this.loading = true;
		this.login(this.emailAddress, this.password)
			.then((response: any) => {
				this.showAlert = false;
				this.alertMessage = "";
				this.setAccessTokenInStorage(response.data.token);
				this.getCurrentUserData();
			})
			.catch((error: any) => {
				this.alertMessage = error.response.data.message;
				this.showAlert = true;
				if (this.alertMessage.includes("verify")) {
					this.showResendVerifyEmail = true;
				} else {
					this.showResendVerifyEmail = false;
				}
			})
			.finally(() => {
				this.loading = false;
			});
	}

	setAccessTokenInStorage(token: string) {
		localStorage.setItem("access_token", token);
	}

	getCurrentUserData() {
		this.getCurrentUser().then((response: AxiosResponse<any>) => {
			this.$store.dispatch("account/updateCurrentUser", response.data);
			this.determineRedirect();
		});
	}

	determineRedirect() {
		if (this.redirectTo == "") {
			this.$router.push(this.defaultRedirectTo);
		} else {
			this.$router.push(this.redirectTo);
		}
	}

	get canAttemptLogin(): boolean {
		return this.formValid;
	}

	private isSet(text: string): boolean {
		return text != undefined && text != null && text != "";
	}

	attemptResendEmailVerification(): void {
		this.sendingVerificationEmail = true;
		this.resendVerificationEmail(this.emailAddress)
			.then(() => {
				this.verificationEmailReSent = true;
				this.showAlert = false;
			})
			.catch(() => {})
			.finally(() => (this.sendingVerificationEmail = false));
	}
}
